<div class="standard-workspace container-fluid" style="background-color: #222222">
   <div class="row">
      <div class="col-lg-12">
         <callsmart-calendar class="black-calendar" [scheduleEvents]="diaryEvents" [numberOfWeeks]="6"
                             [canSelectDayOfWeek]="false"></callsmart-calendar>
      </div>
   </div>
</div>
